import secondaryComponents from "../..";
import { PurchaseOrderImage } from "../../../../assets/svgImages";
import { defaultDateDisplay } from "../../../../helpers";
import { WarningDialog } from "../../../common";
import { usePOShareDialog } from "../POShareDialog/usePOShareDialog";
import { usePurchaseOrderTable } from "./usePurchaseOrderTable";

export const POTable = ({
  purchaseOrders,
  metaDetails,
  gotoPage = () => {},
}) => {
  const { selectedPODetails, setSelectedPODetails, instance } =
    usePurchaseOrderTable({
      purchaseOrders,
    });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  const { isDeletingPO, handleDeletePO } = usePOShareDialog({
    closeModal: () => setSelectedPODetails(null),
  });

  return (
    <>
      <secondaryComponents.TableHelper
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        rows={rows}
        prepareRow={prepareRow}
        hasAction={true}
      >
        <div className="pt-5 text-center">
          <PurchaseOrderImage />
          <h4>You have no Purchase Order</h4>
          <p>
            Use the button above to place a purchase order . When you do, they
            would appear here.
          </p>
        </div>
      </secondaryComponents.TableHelper>

      {/* pagination */}
      {purchaseOrders?.length > 0 && (
        <div className="mt-auto">
          <secondaryComponents.Pagination
            totalPageNumber={metaDetails?.last_page}
            handlePageClick={(value) => gotoPage(value?.selected + 1)}
            currentPage={metaDetails?.current_page}
          />
        </div>
      )}

      <secondaryComponents.Modal
        isActive={!!selectedPODetails}
        width={550}
        closeModal={() => setSelectedPODetails(null)}
      >
        <WarningDialog
          title={`Delete PO: ${selectedPODetails?.po_number}`}
          closeModal={() => setSelectedPODetails(null)}
          handler={() => handleDeletePO(selectedPODetails)}
          isLoading={isDeletingPO}
        >
          <p>
            Supplier:{" "}
            <span className="dark--text">
              {selectedPODetails?.supplier?.name}
            </span>
          </p>
          <p>
            PO Date:{" "}
            <span className="dark--text">
              {selectedPODetails?.po_date
                ? defaultDateDisplay(selectedPODetails?.po_date)
                : "N/A"}
            </span>
          </p>
        </WarningDialog>
      </secondaryComponents.Modal>
    </>
  );
};
